import {MassCampaignStatusEnum} from '@/services/api-clients';
import i18n from '@/i18n/config';
import { LF } from '@/i18n/LF';

export function massCampaignStatusNameFilter(status: MassCampaignStatusEnum): string {
  switch (status) {
    case MassCampaignStatusEnum.Waiting: return i18n.t(LF.Waiting) as string;
    case MassCampaignStatusEnum.Approved: return i18n.t(LF.Approved) as string;
    case MassCampaignStatusEnum.Pending: return i18n.t(LF.Pending) as string;
    case MassCampaignStatusEnum.Executed: return i18n.t(LF.Finished) as string;
  }
}
